/* eslint-disable jsx-a11y/anchor-is-valid */
import 'flatpickr/dist/themes/material_blue.css'

import React from 'react'
import Flatpickr from 'react-flatpickr'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { values } from 'lodash'
import UIkit from 'uikit'

// Components
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'
import DraggableSections from 'app/views/components/DraggableSections'
import Icon from 'app/views/components/Icon'

// Redux
import { getContent } from 'app/state/modules/content'
import { fetchAssessments } from 'app/state/modules/assessments'
import { addPlanGroup, getPlanById } from 'app/state/modules/plan'

// Utils
import analytics from 'app/views/utils/analytics'


class OrganizationsPlansPhaseAdd extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: '',
      title: '',
      description: '',
      startDate: null,
      endDate: null,
      duration: '',
      isLoading: true,
      contentType: 'lessons',
    }

    this.handleChangeTitle = this.handleChangeTitle.bind(this)
    this.handleChangeDescription = this.handleChangeDescription.bind(this)
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this)
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
    this.handleSubmitSave = this.handleSubmitSave.bind(this)
    this.handleChangeDuration = this.handleChangeDuration.bind(this)
    this.activateDragListeners = this.activateDragListeners.bind(this)
  }

  componentDidMount() {
    this.props.getPlanById(this.props.match.params.organization_uuid, this.props.match.params.plan_uuid)
    this.props.getContent(this.props.match.params.organization_uuid, true, () => this.setState({ isLoading: false }))
    this.props.fetchAssessments(this.props.match.params.organization_uuid)

    analytics.page('page-organizations-plans-phase-add')
    if (this.props.content.courses.length > 0) {
      setTimeout(() => {
        this.activateDragListeners()
      }, 500)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.content.courses.length === 0 && this.props.content.courses.length > 0) {
      setTimeout(() => {
        this.activateDragListeners()
      }, 500)
    }
  }

  activateDragListeners() {
    UIkit.util.on('#content-list', 'added', (x) => {
      x.target.children.forEach((child) => {
        if (child.dataset.type === 'coding_challenge' && child.children[0]) {
          child.children[0].innerHTML = child.dataset.selectedName
        }
        if (child.dataset.type === 'lesson' || child.dataset.type === 'app') {
          JSON.parse(child.dataset.contentUuids).forEach((contentUUID) => {
            const element = document.getElementById(`${contentUUID}`)
            let existsElement = false
            for (let el of document.getElementById('content-list').getElementsByTagName('li')) {
              if (el.id === contentUUID) {
                existsElement = true
              }
            }
            if (!existsElement) {
              element.parentNode.removeChild(element)
              document.getElementById('content-list').insertAdjacentElement('beforeend', element)
              if (element.dataset.selectedName) {
                element.innerHTML = element.dataset.selectedName
              }
            }
          })
        }
      })
    })
  }

  handleChangeTitle(event) {
    this.setState({ title: event.target.value })
  }

  handleChangeDescription(event) {
    this.setState({ description: event.target.value })
  }

  handleChangeDuration(event) {
    this.setState({ duration: event.target.value.replace(/[^0-9]+/g, '') })
  }

  handleChangeStartDate(date) {
    this.setState({ startDate: date[0] })
  }

  handleChangeEndDate(date) {
    this.setState({ endDate: date[0] })
  }

  handleSubmitSave(event) {
    event.preventDefault()
    const currentPlan = this.props.planMap[this.props.match.params.plan_uuid]

    if (currentPlan.is_time_based) {
      if (this.state.duration === '' || isNaN(parseInt(this.state.duration, 10)) || parseInt(this.state.duration, 10) < 1) {
        this.setState({ error: 'Duration is required and can\'t be less than 1.' })
        return
      }
    }

    if (!currentPlan.is_time_based && this.state.startDate && this.state.endDate) {
      if (this.state.endDate < this.state.startDate) {
        this.setState({ error: 'End date of phase cannot be before start date' })
        return
      }
    }


    if (this.state.title === '') {
      this.setState({ error: 'Title is required.' })
    } else {
      if (this.props.planMap[this.props.match.params.plan_uuid].groups.length === 0) {
        UIkit.modal('#modal-plan-created').show()
      }

      let startDate = null
      if (this.state.startDate !== null) {
        startDate = this.state.startDate.toISOString().slice(0, 10)
      }

      let endDate = null
      if (this.state.endDate !== null) {
        endDate = this.state.endDate.toISOString().slice(0, 10)
      }

      const contentIds = {}
      const assessmentIds = {}
      const lis = document.getElementById('content-list').getElementsByTagName('li')
      let sortOrder = 1
      lis.forEach((li) => {
        if (li.dataset.type === 'content' || li.dataset.type === 'hacking_challenge' || li.dataset.type === 'coding_challenge') {
          contentIds[li.id] = {
            id: li.id,
            sort_order: sortOrder,
          }
        } else if (li.dataset.type === 'assessment') {
          assessmentIds[li.id] = {
            id: li.id,
            sort_order: sortOrder,
          }
        }
        sortOrder += 1
      })

      this.props.addPlanGroup(
        this.props.match.params.organization_uuid,
        this.props.match.params.plan_uuid,
        this.state.title,
        this.state.description,
        startDate,
        endDate,
        JSON.stringify(Object.values(contentIds)),
        JSON.stringify(Object.values(assessmentIds)),
        this.state.duration,
      ).then(() => {
        this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/plans/${this.props.match.params.plan_uuid}`)
      })
    }
  }

  render() {
    if (!this.props.planMap || !this.props.planMap[this.props.match.params.plan_uuid] || this.state.isLoading) return <div className="uk-text-center uk-padding-large"><div data-uk-spinner="" /></div>
    const currentPlan = this.props.planMap[this.props.match.params.plan_uuid]
    return (
      <OrganizationLayout {...this.props} active="plans" data-test-id="organization-plans-component">
        <h1>Add Training Phase</h1>
        <p className="">
          You can break up your training into different "phases". Choose which lessons you
          would like for the phase, and optionally set an end date for these lessons.
        </p>
        <div className="uk-card uk-card-default uk-card-body">
          <div className="uk-container-medium">
            <form className="uk-form-stacked">
              <div className="uk-margin" style={{ paddingRight: 200 }}>
                <label className="uk-form-label">
                  Phase Title
                  <Icon
                    type="button"
                    href="#"
                    name="information"
                    ratio={0.8}
                    data-uk-toggle="target: #modal-training-phase"
                    style={{ marginLeft: 8, cursor: 'pointer' }}
                  />
                </label>
                <div className="uk-form-controls">
                  <input
                    data-test-id="input-phase-title"
                    className="uk-input"
                    type="text"
                    placeholder=""
                    value={this.state.title}
                    onChange={this.handleChangeTitle}
                  />
                </div>
                <div id="modal-training-phase" data-uk-modal>
                  <div className="uk-modal-dialog uk-modal-body">
                    <h2>What is a Training Phase?</h2>
                    <p>
                      You can break up your training into different "phases". Choose which
                      lessons you would like for the phase, and optionally set an end date for
                      these lessons.
                    </p>
                    <p className="uk-text-right">
                      <button className="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
                    </p>
                    <button className="uk-modal-close-outside" type="button" data-uk-close />
                  </div>
                </div>
              </div>
              <div className="uk-margin" style={{ paddingRight: 200 }}>
                <label className="uk-form-label">Phase Description</label>
                <div className="uk-form-controls">
                  <input
                    data-test-id="input-phase-description"
                    className="uk-input"
                    type="text"
                    placeholder=""
                    value={this.state.description}
                    onChange={this.handleChangeDescription}
                  />
                </div>
                <span className="uk-text-meta">The description shows up on your users' My Plan dashboard.</span>
              </div>
              {currentPlan.is_time_based === false ? (
                <>
                  <div className="uk-margin" style={{ paddingRight: 200 }}>
                    <label className="uk-form-label">Phase Start Date</label>
                    <div className="uk-form-controls">
                      <Flatpickr
                        className="uk-input"
                        value={this.state.startDate}
                        onChange={this.handleChangeStartDate}
                      />
                    </div>
                    <span className="uk-text-meta">The start date is used for training reminders.</span>
                  </div>

                  <div className="uk-margin" style={{ paddingRight: 200 }}>
                    <label className="uk-form-label">Phase End Date</label>
                    <div className="uk-form-controls">
                      <Flatpickr
                        className="uk-input"
                        value={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                      />
                    </div>
                    <span className="uk-text-meta">The end date is used for training reminders.</span>
                  </div>
                </>
              )
                : (
                  <div className="uk-margin" style={{ paddingRight: 200 }}>
                    <label className="uk-form-label">Duration in days</label>
                    <div className="uk-form-controls">
                      <input
                        data-test-id="input-phase-description"
                        className="uk-input"
                        type="text"
                        placeholder=""
                        value={this.state.duration}
                        onChange={this.handleChangeDuration}
                      />
                    </div>
                    <span className="uk-text-meta">The duration that a user has to complete the phase after on-boarding.</span>
                  </div>
                )}
              <div className="uk-margin">
                <label className="uk-form-label">Choose content</label>
                <div className="uk-form-controls uk-form-controls-text">
                  <label className="uk-text-small">
                    <input
                      className="uk-radio uk-margin-small-right"
                      type="radio"
                      onChange={() => this.setState({
                        contentType: 'lessons',
                      })}
                      name="lessons"
                      checked={this.state.contentType === 'lessons'}
                    />
                  Lesson
                  </label>
                  <br />
                  <label className="uk-text-small">
                    <input
                      onChange={() => this.setState({
                        contentType: 'coding_challenges',
                      })}
                      checked={this.state.contentType === 'coding_challenges'}
                      className="uk-radio uk-margin-small-right"
                      type="radio"
                      name="coding_challenges"
                    />
                    Coding Challenges
                  </label>
                  <br />
                  <label className="uk-text-small">
                    <input
                      onChange={() => this.setState({
                        contentType: 'assessments',
                      })}
                      checked={this.state.contentType === 'assessments'}
                      className="uk-radio uk-margin-small-right"
                      type="radio"
                      name="assessments"
                    />
                    Assessments
                  </label>
                  <br />
                  {/* <label className="uk-text-small">
                    <input
                      onChange={() => this.setState({
                        contentType: 'articles',
                      })}
                      checked={this.state.contentType === 'articles'}
                      className="uk-radio uk-margin-small-right"
                      type="radio"
                      name="articles"
                    />
                    Articles
                  </label> */}
                </div>
              </div>
              <div className="uk-margin">
                <div className="uk-form-controls">
                  <div data-uk-grid>
                    <DraggableSections
                      contentType="lessons"
                      initialShow
                      content={this.props.content}
                      display={this.state.contentType === 'lessons' ? 'block' : 'none'}
                    />
                    <DraggableSections
                      contentType="coding_challenges"
                      content={this.props.content}
                      display={this.state.contentType === 'coding_challenges' ? 'block' : 'none'}
                      defaultFilters={this.props.planMap[this.props.match.params.plan_uuid].mainEngines.reduce((prev, { language }) => {
                        prev[language] = true
                        return prev
                      }, {})}
                    />
                    <DraggableSections
                      contentType="assessments"
                      content={this.props.assessments}
                      display={this.state.contentType === 'assessments' ? 'block' : 'none'}
                    />
                    {/* <DraggableSections
                      content={this.props.content.articles}
                      display={this.state.contentType === 'articles' ? 'block' : 'none'}
                    /> */}
                    <div>
                      <label className="uk-form-label">Selected Lessons</label>
                      <ul data-test-id="choose-lesson-right" className="uk-placeholder uk-padding-small uk-nav draggable uk-nav-default uk-width-medium" id="content-list" data-uk-sortable="group: sortable-group" style={{ minHeight: 'calc(100% - 40px)' }} />
                    </div>
                  </div>
                </div>
                <div id="modal-choose-lessons" data-uk-modal>
                  <div className="uk-modal-dialog uk-modal-body">
                    <h2>Choose Lessons</h2>
                    <p>
                      Drag lessons from the left column into the "Selected Lessons" column to
                      add them to your training plan. Drag the lessons up and down to order
                      them.
                    </p>
                    <p className="uk-text-right">
                      <button className="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
                    </p>
                    <button className="uk-modal-close-outside" type="button" data-uk-close />
                  </div>
                </div>
              </div>

              {(this.state.error !== '') && (
                <div className="uk-margin">
                  <p className="uk-text-danger">{this.state.error}</p>
                </div>
              )}

              <div className="uk-margin">
                <div className="uk-form-controls">
                  <button
                    data-test-id="save-btn"
                    className="uk-button uk-button-primary tm-button-default"
                    onClick={this.handleSubmitSave}
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </div>

            </form>
          </div>
        </div>
        <div id="modal-plan-created" data-uk-modal data-test-id="modal-plan-creation-confirm" >
          <div className="uk-modal-dialog uk-modal-body">
            <h2>Success!</h2>
            <p>
              You've successfully created a custom training plan!
            </p>
            <p>
              You can add phases by clicking the blue <strong>Add Training Phase</strong> button.
            </p>
            <p className="uk-text-right">
              <button
                data-test-id="ok-btn"
                className="uk-button uk-button-primary tm-button-primary uk-modal-close"
                type="button"
              >
                Ok
              </button>
            </p>
            <button className="uk-modal-close-outside" type="button" data-uk-close />
          </div>
        </div>
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  // content
  content: state.content.content,
  courses: state.content.courses,
  lessonMap: state.content.lessonMap,
  tests: state.content.tests,

  // hacker
  organizations: values(state.hacker.organizationsList),
  organizationsHash: state.hacker.organizationsHash,

  // plans
  loadingPlans: state.plan.loadingPlans,
  hasLoadedPlans: state.plan.hasLoadedPlans,
  planMap: state.plan.planMap,

  // user
  email: state.auth.user.email,

  assessments: {
    assessments: state.assessments.customAssessments,
  },
})
const mapDispatchToProps = (dispatch) => ({
  addPlanGroup: (organizationId, planId, title, description, startDate, endDate, contentIds, assessmentsId, duration) => dispatch(addPlanGroup(organizationId, planId, title, description, startDate, endDate, contentIds, assessmentsId, duration)),
  getPlanById: (organizationId, planId) => dispatch(getPlanById(organizationId, planId)),
  getContent: (organizationUUID, includeAllOrganizationContent, callback) => dispatch(getContent(organizationUUID, includeAllOrganizationContent, callback)),
  fetchAssessments: (organizationUUID) => dispatch(fetchAssessments(organizationUUID)),
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrganizationsPlansPhaseAdd))
